import React, { useState } from "react";
import { Link } from "react-router-dom";
import ContentPage from "../../components/layout/contentPage";
import { Col, Row, VImage } from "../../style/base.style";
import { servicePlans } from "../../assets/constant/services";
import { useDictionary } from "../../contexts/dictionary";
import { ActionButton, ButtonStyle } from "../../components/buttons/ActionButton";
import { useDeviceType } from "../../contexts/DeviceContext";
import { ServiceBenefits } from "./serviceBenefits";





export const ServicesPage = () => {
    const {translate} = useDictionary();
    const {isMobile} = useDeviceType();

  return (
    <div className="main-wrapper">
        <ContentPage title={translate("services")}>
            <Col $gap={20} $margin="20px 0px" $width={isMobile?"90%":"75%"} $alignSelf="center">

         
            <Row $width="100%" >
         <Col $width="100%" $gap={20}>
            
            
              {/* Doctor Widget */}
             {
                servicePlans.map((service, index) => (
                    <Col $padding="10px" $width="100%" $backgroundColor="#fff" $border="1px solid #e0e0e0" $borderRadius={10} $gap={20} key={index}>
                     
                        <Row $justifyContent={isMobile?"center":"space-between"} $width="100%">
                            <Col $width={isMobile?"100%":"60%"} $gap={10}>
                            <Row $gap={10} $justifyContent={isMobile?"center":"space-between"}>
                                <Col $alignSelf="flex-start" $width="200px" $justifyContent="center">
                                    
                                        <Link to={`/services/${service.id}`}>
                                        <VImage
                                            $width={'200px'}
                                            src={service.img}
                                            className="img-fluid"
                                            alt="User Image"
                                            $borderRadius="10px"
                                        />
                                        </Link>
                                    
                                </Col>
                                <Col flex="1">
                                <div className="doc-info-cont">
                                    <h4 className="doc-name mb-2">
                                    <Link to={`/services/${service.id}`}>
                                        {translate(service.name)}
                                    </Link>
                                    </h4>
                                    <div className="rating mb-2">
                                    <span className="badge badge-primary">{service.rate.toFixed(1)}</span>
                                    {Array.from({ length: Math.floor(service.rate) }).map((_, i) => (
                                                <i key={i} className="fas fa-star filled" />))}

                                        {Array.from({ length: Math.floor(5-service.rate) }).map((_, i) => (
                                                <i key={i} className="fas fa-star"/>))}
                                    
                                    
                                    <span className="d-inline-block average-rating ms-1">
                                        ({service.votes})
                                    </span>
                                    </div>
                                <ServiceBenefits benefits={service.benefits} />
                                </div>
                                </Col>
                            </Row>
                           
                        
                       
                        
                            </Col>
                            <Col $alignSelf="flex-end" $padding="20px" $gap={10}>
                            
                            <ActionButton width="125px" style={ButtonStyle.light} route={`/services/${service.id}`} label={translate('view_details')} />
                            <ActionButton width="125px" route={`/services/${service.id}`} label={translate('join_now')} />
                            
                           
                           
                          
                        
                            </Col>
                     
                      
                        </Row>
                        
                     
                        </Col>
                ))
             }
              {/* /Doctor Widget */}
        
           
            
            </Col>
            </Row>
         
     
            
            </Col>

      

        </ContentPage>
    

    </div>
  );
};


